/* Flowcart — guest order tracking.
   Calls a Supabase SECURITY DEFINER function. One input accepts either a
   10-digit phone number or an order number; whichever the customer types is
   detected here and sent in the matching field. The table itself has RLS with
   no anon policies, so it is never readable directly. */
(function () {
  'use strict';

  var root = document.querySelector('[data-track-root]');
  if (!root) return;

  var base = (root.getAttribute('data-supabase-url') || '')
    .trim().replace(/\/+$/, '').replace(/\/rest\/v1(\/.*)?$/, '');
  var key = root.getAttribute('data-supabase-key');
  if (!base || !key) return;

  var form = root.querySelector('[data-track-form]');
  var errorEl = root.querySelector('[data-track-error]');
  var resultEl = root.querySelector('[data-track-result]');
  var submitBtn = root.querySelector('[data-track-submit]');

  var headers = { apikey: key, 'Content-Type': 'application/json' };
  if (key.indexOf('eyJ') === 0) headers.Authorization = 'Bearer ' + key;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function fail(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
    resultEl.hidden = true;
  }

  function fmt(d) {
    if (!d) return '';
    var dt = new Date(d);
    if (isNaN(dt)) return '';
    return dt.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  // Same courier map as the logged-in order page
  function courierUrl(courier, awb) {
    var c = String(courier || '').toLowerCase().replace(/\s+/g, '');
    var a = encodeURIComponent(awb);
    if (c.indexOf('delhivery') > -1)   return 'https://www.delhivery.com/track/package/' + a;
    if (c.indexOf('bluedart') > -1)    return 'https://www.bluedart.com/web/guest/trackdartresult?trackFor=0&trackNo=' + a;
    if (c.indexOf('ekart') > -1)       return 'https://ekartlogistics.com/shipmenttrack/' + a;
    if (c.indexOf('xpressbees') > -1)  return 'https://www.xpressbees.com/shipment/tracking?awbNo=' + a;
    if (c.indexOf('shadowfax') > -1)   return 'https://track.shadowfax.in/#/consumer-tracking/' + a;
    if (c.indexOf('ecom') > -1)        return 'https://ecomexpress.in/tracking/?awb_field=' + a;
    if (c.indexOf('shiprocket') > -1)  return 'https://shiprocket.co/tracking/' + a;
    if (c.indexOf('dtdc') > -1)        return 'https://www.dtdc.in/tracking.asp';
    if (c.indexOf('indiapost') > -1)   return 'https://www.indiapost.gov.in/_layouts/15/DOP.Portal.Tracking/TrackConsignment.aspx';
    return 'https://www.google.com/search?q=' + encodeURIComponent((courier || '') + ' track ' + awb);
  }

  var STAGES = { confirmed: 2, shipped: 3, out_for_delivery: 4, delivered: 5 };

  function cardHtml(r) {
    var cancelled = r.status === 'cancelled';
    var stage = cancelled ? 0 : (STAGES[r.status] || 1);
    var courier = r.courier || 'Courier';

    var badge = cancelled
      ? '<span class="tracking__badge tracking__badge--cancelled">Cancelled</span>'
      : (stage >= 5
        ? '<span class="tracking__badge tracking__badge--done">Delivered</span>'
        : '<span class="tracking__badge">' + esc(String(r.status).replace(/_/g, ' ')) + '</span>');

    var awbHtml = '';
    if (r.awb) {
      var url = courierUrl(r.courier, r.awb);
      awbHtml =
        '<div class="tracking__awb"><div>' +
          '<span class="tracking__awb-label">' + esc(courier) + ' · AWB</span>' +
          '<a class="tracking__awb-number" href="' + esc(url) + '" target="_blank" rel="noopener">' + esc(r.awb) + '</a>' +
        '</div>' +
        '<a class="btn tracking__awb-btn" href="' + esc(url) + '" target="_blank" rel="noopener">Track on ' + esc(courier) + ' &rarr;</a></div>';
    }

    var steps = [
      ['Order placed', 'Received'],
      ['Order confirmed', stage >= 2 ? 'Verified and packed' : 'We\u2019ll confirm on WhatsApp'],
      ['Shipped', r.shipped_at ? fmt(r.shipped_at) + ' · ' + esc(courier) : 'Usually within 24 hours'],
      ['Out for delivery', stage >= 4 ? 'Arriving today' : '3\u20137 days from dispatch'],
      ['Delivered', r.delivered_at ? fmt(r.delivered_at) : 'Keep cash ready for the agent']
    ];

    var body = cancelled
      ? '<p class="tracking__cancelled">This order was cancelled.</p>'
      : '<ol class="tracking__steps">' + steps.map(function (s, i) {
          return '<li class="tracking__step ' + (i + 1 <= stage ? 'is-done' : '') + '">' +
            '<span class="tracking__dot"></span><div><strong>' + s[0] + '</strong>' +
            '<span class="tracking__when">' + s[1] + '</span></div></li>';
        }).join('') + '</ol>';

    return '<div class="tracking">' +
        '<div class="tracking__head"><h2>Order ' + esc(r.order_number) + '</h2>' + badge + '</div>' +
        awbHtml + body +
        (r.note ? '<p class="tracking__note">' + esc(r.note) + '</p>' : '') +
      '</div>';
  }

  function render(rows) {
    var head = rows.length > 1
      ? '<p class="track-result__count">' + rows.length + ' recent orders for this number</p>'
      : '';
    resultEl.innerHTML = head + rows.map(cardHtml).join('');
    resultEl.hidden = false;
    errorEl.hidden = true;
  }

  // One box, two kinds of input. Digits-only and 10+ long reads as a phone
  // number; anything else (has "#", letters, or too few digits) reads as an
  // order number.
  function classify(raw) {
    var digits = raw.replace(/\D/g, '');
    var looksPhone = digits.length >= 10 && !/[^0-9\s+\-()]/.test(raw);
    if (looksPhone) return { p_order: '', p_phone: raw };
    return { p_order: raw, p_phone: '' };
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var fd = new FormData(form);
    var q = (fd.get('q') || '').trim();

    if (!q) return fail('Please enter your order number or phone number.');

    var digits = q.replace(/\D/g, '');
    // A bare run of digits shorter than 10 is ambiguous: too short for a phone
    // number, and order numbers are usually typed with a "#". Accept it as an
    // order number, but catch the half-typed phone number case.
    if (/^[0-9\s+\-()]+$/.test(q) && digits.length >= 6 && digits.length < 10) {
      return fail('That looks like an incomplete phone number. Enter all 10 digits, or your order number like #1001.');
    }

    var payload = classify(q);

    submitBtn.disabled = true;
    submitBtn.textContent = 'Checking…';

    fetch(base + '/rest/v1/rpc/track_order', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error(r.status)); })
      .then(function (rows) {
        if (!Array.isArray(rows)) rows = rows ? [rows] : [];
        if (!rows.length) {
          // deliberately vague: don't reveal whether an order exists
          return fail('No orders found. Check the order number or the phone number you ordered with, or message us on WhatsApp.');
        }
        render(rows);
      })
      .catch(function () { fail('Tracking is unavailable right now. Please try again shortly.'); })
      .then(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Track order';
      });
  });
})();
